const data = {
  type: "",
  result: {
    jobduty:
      "1、负责公司总部人事管理工作，包括但不限于员工招聘、培训、绩效评估和薪酬福利管理；\n 2、制定和完善人力资源相关政策及流程，确保符合法律法规和公司战略目标；\n 3、建立和优化人才梯队建设机制，为公司提供持续的人才支持；\n 4、组织开展员工关系管理活动，促进良好的企业文化建设；5、分析并解决人力资源管理中的问题，提出改进建议并实施。dddd",
    jobrequire:
      "1、本科及以上学历，人力资源或相关专业毕业；2、具备至少5年以上人事管理相关工作经验；3、熟悉国内外人力资源管理法律法规及最佳实践；4、具有较强的组织协调能力和团队领导能力；5、良好的沟通能力和亲和力，能够处理复杂的员工关系问题。",
  },
};

export { data };
